import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { HTTP_STATUS } from "../../http/constants/http.status";
import { AppConstants } from "../../constants/AppConstants";
import { useTheme } from "../../context/themeContext";
import Modal from "../shared/ModalPortal/Modal";

const isPhoneNumber = (text: string) =>
  /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./a-zA-Z0-9]*$|^\(\d{2}\)\(\d{2}\)\d{4}-\d{4}$/g.test(
    text
  );

const isWebsite = (text: string) => {
  var res = text.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );
  return res !== null;
};

const isEmailAddress = (text: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text);

import LoaderContainer from "../shared/loaderContainer/LoaderContainer";
import { lowerCase } from "lodash";
import { Label } from "../Auth/AuthStyles";

interface ModalProps {
  visibility: boolean;
  setVisibility: Function;
  country: string;
}

const AdverseEventsInfo = ({
  visibility,
  setVisibility,
  country,
}: ModalProps) => {
  const { t } = useTranslation(AppConstants.LOCALISATION_NAMESPACE_ADVERSE);

  const theme = useTheme().theme;

  const data: any = t(country, { returnObjects: true });
  const parsedData = typeof data === "string" ? JSON.parse(data) : data;

  const handleClick = (value: string) => {
    if (isPhoneNumber(value)) {
      window.location.href = `tel:${value}`;
    } else if (isEmailAddress(value)) {
      window.location.href = `mailto:${value}`;
    } else if (isWebsite(value)) {
      const websiteLink =
        value.startsWith("http://") || value.startsWith("https://")
          ? value
          : `https://${value}`;
      window.open(websiteLink, "_blank");
    }
  };

  return (
    <Modal
      overflowVisible={false}
      showCloseIcon={true}
      width="85rem"
      showHeader
      headerText={parsedData?.["T_TITLE"]}
      headerStyles="!md:text-3xl !text-2xl"
      toggleVisiblity={(value: boolean) => {
        setVisibility(value);
      }}
      isVisible={visibility}
      containerBackgroundColor={theme.secondary2}
      headerBackgroundColor={theme.whiteAppColor}
      primaryButtonText={parsedData?.["T_BUTTON"]}
      primaryOnClick={() => {
        setVisibility(false);
      }}
      primaryButtonWidth="15%"
      customHeaderComponent={<></>}
      body={
        <LoaderContainer isLoading={false}>
          <div className="w-full rounded-lg">
            <ul className="my-4 pl-5 text-center">
              {parsedData?.["T_CONTENT"]?.map(
                (point: string = "", index: any) =>
                  isEmailAddress(point) ||
                  isPhoneNumber(point) ||
                  isWebsite(point) ? (
                    <li
                      onClick={() => {
                        handleClick(point);
                      }}
                      className="mb-2 cursor-pointer text-base sm:text-lg md:text-xl"
                      style={{ color: theme.secondary1 }}
                    >
                      {point}
                    </li>
                  ) : (
                    <li
                      key={index}
                      className="mb-2 text-base sm:text-lg md:text-xl"
                    >
                      {point}
                    </li>
                  )
              )}
            </ul>
          </div>
        </LoaderContainer>
      }
    />
  );
};

export default AdverseEventsInfo;
